/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as css from './Icon.scss';

const Icon = ({ type, className }) => {
	const getIcon = () => {
		switch (type) {
			case Icon.PLAY: {
				return (
					<svg width="28.334" height="28.333" viewBox="0 0 28.334 28.333">
						<g transform="translate(-638 -3289)">
							<g className={css.shape1Play} transform="translate(638 3289)">
								<circle cx="14.167" cy="14.167" r="13.167" />
							</g>
							<path
								d="M5.111 6.814a1.423 1.423 0 0 0 1.777 0l4.754-5.049c.771-.658.214-1.765-.888-1.765H1.246C.144 0-.413 1.107.358 1.764z"
								className={css.shape2Play}
								transform="rotate(-90 1979.77 1329.77)"
							/>
						</g>
					</svg>
				);
			}

			case Icon.ACCESSABILITY: {
				return (
					<svg className={css.access} width="50.659" height="50.659" viewBox="0 0 50.659 50.659">
						<g className={css.shape2}>
							<g className={css.shape1Access}>
								<path
									d="M25.329 0A25.33 25.33 0 1 1 0 25.33 25.33 25.33 0 0 1 25.329 0z"
									className={css.shape1Access}
								/>
								<path d="M25.33 2A23.254 23.254 0 0 0 8.833 8.833 23.254 23.254 0 0 0 1.999 25.33a23.254 23.254 0 0 0 6.833 16.497 23.254 23.254 0 0 0 16.496 6.832 23.254 23.254 0 0 0 16.496-6.833A23.254 23.254 0 0 0 48.66 25.33a23.254 23.254 0 0 0-6.833-16.497A23.254 23.254 0 0 0 25.329 2m0-2c13.99 0 25.33 11.34 25.33 25.33 0 13.989-11.34 25.33-25.33 25.33C11.34 50.66 0 39.318 0 25.33 0 11.34 11.34 0 25.33 0z" />
							</g>
							<path
								className={css.shape3}
								d="M594.185 544.7a1.418 1.418 0 0 0-1.116-.5l-2.111.024-3.393-9.273-9.047.019-.128-2.146-.321-3.685-.127-2.509a3.93 3.93 0 0 1-4.039.169l1.226 11.938 9.8-.006 3.6 9.04 5.942-.036.1-.543a3.424 3.424 0 0 0-.386-2.492z"
								// eslint-disable-next-line react/jsx-no-duplicate-props
								className={css.shape1}
								transform="translate(-553.534 -511.957)"
							/>
							<path
								className={css.shape3}
								id="Path_112"
								d="M579.491 550.105a12.083 12.083 0 1 1-15.9-18.172l.51-.411 2.531 3.034-.533.423a8.132 8.132 0 0 0 9.952 12.86l.322-.242 3.823 1.841z"
								// eslint-disable-next-line react/jsx-no-duplicate-props
								className={css.shape1}
								transform="translate(-547.917 -513.813)"
							/>
							<ellipse
								id="Ellipse_7"
								cx="3.324"
								cy="3.324"
								className={css.shape1}
								rx="3.324"
								ry="3.324"
								transform="translate(18.925 8.047)"
							/>
						</g>
					</svg>
				);
			}

			case Icon.TOGGLE_SHARE: {
				return (
					<svg width="50.659" height="50.659" viewBox="0 0 50.659 50.659">
						<g transform="translate(-50)">
							<g id="face_web" className={css.shape2} transform="translate(50)">
								<path
									id="Path_339"
									d="M25.329 0A25.33 25.33 0 1 1 0 25.33 25.33 25.33 0 0 1 25.329 0z"
									className={css.shape1}
								/>
							</g>
							<path
								d="M619.538 499.153l-6.075-4.752a5.534 5.534 0 0 0 0-4.951l6.075-4.752a5.516 5.516 0 1 0-1.9-4.8 5.555 5.555 0 0 0 .556 3.093l-6.072 4.749a5.509 5.509 0 1 0 0 8.367l6.072 4.749a5.52 5.52 0 0 0 1.022 6.382 5.511 5.511 0 1 0 .317-8.087z"
								className={css.shape2}
								transform="translate(-541.512 -466.429)"
							/>
						</g>
					</svg>
				);
			}

			case Icon.FACEBOOK: {
				return (
					<svg className={css.fb} width="50.659" height="50.659" viewBox="0 0 50.659 50.659">
						<g id="face_web" transform="translate(8)">
							<path
								d="M25.329 0A25.33 25.33 0 1 1 0 25.33 25.33 25.33 0 0 1 25.329 0z"
								className={css.shape1}
								transform="translate(-8)"
							/>
							<path
								id="Path_110"
								d="M882.734 519.088s-4.2-1.531-4.2 1.586v2.356h4.1l-.363 3.891h-3.732v13.259h-5.019v-13.259h-2.458v-3.891h2.458v-4.094s-.052-3.16 4.069-4.07a12.118 12.118 0 0 1 5.706.282z"
								className={css.shape2}
								transform="translate(-859.261 -502.137)"
							/>
						</g>
					</svg>
				);
			}

			case Icon.TWITTER: {
				return (
					<svg width="50.659" height="50.659" viewBox="0 0 50.659 50.659">
						<g transform="translate(-154 -26)">
							<g transform="translate(94 26)">
								<path
									id="Path_741"
									d="M25.329 0A25.33 25.33 0 1 1 0 25.33 25.33 25.33 0 0 1 25.329 0z"
									className={css.shape1}
									transform="translate(60)"
								/>
							</g>
							<path
								d="M385.752 355.983a4.354 4.354 0 0 1-1.267.166l.023-.135a10.4 10.4 0 0 0 2.545-2.909c.1-.328-.017-.441-.018-.452l-2.127.9-1.779.8a7.1 7.1 0 0 0-5.167-2.129c-3.7 0-6.7 2.621-6.7 5.855a8.689 8.689 0 0 0 .274 2.209c0 .169.007-.17 0 0a20.906 20.906 0 0 1-8.155-2.42c-5.364-2.718-5.7-4.6-5.7-4.6-.843.895-1.277 3.857-.423 6.18a7.7 7.7 0 0 0 2.426 2.821 5.692 5.692 0 0 1-1.721-.282 3.8 3.8 0 0 1-1.213-.593c-.523 1.277.527 3.557 2.342 5.192a9.619 9.619 0 0 0 2.99 1.552l-3.019.085c-.17 2.935 6.154 4.677 6.154 4.677a10.336 10.336 0 0 1-6.309 2.293 12.027 12.027 0 0 1-3.444-.5 16.424 16.424 0 0 0 11.215 4.017c11.29-.593 17.663-10.3 17.967-19.829l.015.02a7.917 7.917 0 0 0 1.66-1.4 11.684 11.684 0 0 0 1.834-2.455s-1.692.741-2.403.937z"
								className={css.shape2}
								transform="translate(-192.463 -314.231)"
							/>
						</g>
					</svg>
				);
			}

			case Icon.WHATSAPP: {
				return (
					<svg className={css.whatsapp} width="50.659" height="50.659" viewBox="0 0 50.659 50.659">
						<g transform="translate(-154 -26)">
							<g transform="translate(94 26)">
								<path
									id="Path_741"
									d="M25.329 0A25.33 25.33 0 1 1 0 25.33 25.33 25.33 0 0 1 25.329 0z"
									className={css.shape1}
									transform="translate(60)"
								/>
							</g>
							<g transform="translate(-63.081 -191.08)">
								<g id="Group_407" data-name="Group 407" transform="translate(227.08 227.08)">
									<path
										id="Path_747"
										d="M242.576 258.072a15.463 15.463 0 0 1-7.8-2.106l-7.215 1.968 2.36-6.418a15.511 15.511 0 1 1 12.659 6.557zm-7.522-4.1l.341.212a13.656 13.656 0 1 0-3.706-3.376l.3.4-1.47 4z"
										className={css.shape2}
										transform="translate(-227.08 -227.08)"
									/>
								</g>
								<g transform="translate(235.024 234.492)">
									<path
										id="Path_748"
										d="M369.175 357.691a1.3 1.3 0 0 1 1.053.1 2.371 2.371 0 0 1 .488.421l2.345 2.345a1.293 1.293 0 0 1 .385.908 1.38 1.38 0 0 1-.232.788 2.846 2.846 0 0 1-.327.371c-.378.38-.76.756-1.136 1.138.107.23.245.444.366.667s.26.44.4.655a11.2 11.2 0 0 0 1.716 2.14 11.045 11.045 0 0 0 1.985 1.557c.425.278.87.522 1.316.762q.633-.635 1.269-1.269a1.4 1.4 0 0 1 .555-.355 1.294 1.294 0 0 1 1 .047 2.144 2.144 0 0 1 .605.5l2.319 2.32a1.34 1.34 0 0 1 .385.907v.06a1.557 1.557 0 0 1-.152.572 3.577 3.577 0 0 1-.715.809 1.567 1.567 0 0 1-.36.309 4.212 4.212 0 0 1-1.232.631 4.1 4.1 0 0 1-.637.156 2.332 2.332 0 0 1-.718.03 6.2 6.2 0 0 1-.9-.1c-.265-.033-.52-.114-.781-.167-.258-.081-.522-.143-.772-.246-.324-.1-.628-.244-.941-.368-.28-.133-.557-.271-.833-.412-.381-.22-.767-.43-1.128-.682-.45-.28-.863-.611-1.287-.927a20.264 20.264 0 0 1-1.349-1.185c-.4-.367-.77-.773-1.151-1.163a17.448 17.448 0 0 1-2.863-3.852 7.763 7.763 0 0 1-.778-2.334 6.209 6.209 0 0 1-.051-1.758 4.282 4.282 0 0 1 .811-2.191.96.96 0 0 1 .121-.189l.589-.591a1.46 1.46 0 0 1 .635-.404z"
										className={css.shape2}
										transform="translate(-366.983 -357.621)"
									/>
								</g>
							</g>
						</g>
					</svg>
				);
			}

			default:
				return null;
		}
	};

	return <div className={classNames(css.icon, className)}>{getIcon()}</div>;
};

Icon.FACEBOOK = 'facebook';
Icon.TWITTER = 'twitter';
Icon.WHATSAPP = 'whatsapp';
Icon.TOGGLE_SHARE = 'toggle-share';
Icon.ACCESSABILITY = 'accessability';
Icon.PLAY = 'play';

Icon.defaultProps = {
	className: '',
};

Icon.propTypes = {
	type: PropTypes.oneOf([
		Icon.PLAY,
		Icon.TWITTER,
		Icon.FACEBOOK,
		Icon.WHATSAPP,
		Icon.TOGGLE_SHARE,
		Icon.ACCESSABILITY,
	]).isRequired,
	className: PropTypes.string,
};

export default Icon;
